import React from 'react'
import PropTypes from 'prop-types'

const ProgressTimeline = ({ currentStep, steps }) => {
  const renderStep = (step, index, arr) => (
    <React.Fragment key={`step_${step}`}>
      <div className={`dot ${index <= currentStep ? 'active' : ''}`}>
        <div className="step-description">{step}</div>
      </div>
      {index + 1 !== arr.length ? (
        <div className={`line ${index < currentStep ? 'active' : ''}`} />
      ) : null}
    </React.Fragment>
  )

  return (
    <div className="progressbar">
      <div className="col">{steps.map(renderStep)}</div>
    </div>
  )
}

ProgressTimeline.propTypes = {
  currentStep: PropTypes.number,
  steps: PropTypes.array,
}

export default ProgressTimeline
